import { render, staticRenderFns } from "./surface_title.vue?vue&type=template&id=228ee049&scoped=true&"
import script from "./surface_title.vue?vue&type=script&lang=js&"
export * from "./surface_title.vue?vue&type=script&lang=js&"
import style0 from "./surface_title.vue?vue&type=style&index=0&id=228ee049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ee049",
  null
  
)

export default component.exports